import { i18nNsFactory } from '@atlas-frontend/i18n';
import { useMemo } from 'react';
import translations from './CategoryMappingDetailTable.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'use-category-table-options'
);
addTranslations(translations);

export function useCategoryTypeOptions() {
  const { t } = useTranslation();

  return useMemo(
    () =>
      ['category', 'category_group', 'combined_group'].map((key) => ({
        id: key,
        name: t(`categoryType.${key}`),
      })),
    [t]
  );
}
